(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var slides = [].slice.call(root.querySelectorAll('.dbt-slide'));
    var bars = [].slice.call(root.querySelectorAll('.dbt-car__bar'));
    if (slides.length < 2) return;
    var PER = parseInt(root.getAttribute('data-per'), 10) || 7000;
    var cur = 0, timer = null, paused = false, startedAt = 0, left = PER;
    root.style.setProperty('--per', PER + 'ms');

    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === cur;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        [].forEach.call(s.querySelectorAll('a'), function (a) { a.tabIndex = on ? 0 : -1; });
      });
      bars.forEach(function (b, k) {
        b.classList.toggle('is-on', k === cur);
        b.classList.toggle('is-done', k < cur);
        b.setAttribute('aria-current', k === cur ? 'true' : 'false');
        var f = b.firstElementChild; if (f) { f.style.animation = 'none'; void f.offsetWidth; f.style.animation = ''; }
      });
      // la matrice recalcule les zones noires autour du texte de la diapo affichee (l'evenement remonte jusqu'a la scene commune)
      root.dispatchEvent(new Event('dbt:slide', { bubbles: true }));
      left = PER; schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (reduce || paused) return;
      startedAt = Date.now();
      timer = setTimeout(function () { show(cur + 1); }, left);
    }
    function pause() { if (paused) return; paused = true; left = Math.max(600, left - (Date.now() - startedAt)); clearTimeout(timer); root.classList.add('is-paused'); }
    function resume() { if (!paused) return; paused = false; root.classList.remove('is-paused'); schedule(); }

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else resume(); });

    bars.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('.dbt-car__prev'), next = root.querySelector('.dbt-car__next');
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });

    if (window.IntersectionObserver) new IntersectionObserver(function (e) { if (e[0].isIntersecting) resume(); else pause(); }).observe(root);
    show(0);
  }

  [].forEach.call(document.querySelectorAll('#pandora, #pandora2, #pandora3, #pandora4, #pandora5'), init);
})();
